export enum IMessageFolderType {
    Inbox = 0,
    Sent = 1,
    Overdue = 2,
    Archive = 3,
    Case = 4
}